/* eslint-disable */
import { message, Modal } from 'antd'
import fetch from 'isomorphic-fetch'
import * as Sentry from '@sentry/react'
import actionTypes from '../constants/actionTypes'
import fetchHelper from '../utils/fetchHelper'
import { generateAllActiveModules } from '../utils/activeModules'
import exceptionHelper, { Status } from '../utils/exceptionHelper'
import * as SentryUtils from '../utils/sentryUtils'
import sensors, { parsePlaceValue, abtest, sensorsRole } from '../utils/sensors'
import desktopLib from '../utils/desktopLib'
import { withClientPrefix } from '../utils/clientAttribution'
import CONFIG from '../constants/config'
import { setMyRole } from './group'
import { setGroupAuthPolicy } from '../slices/groupSlice'
// utils/cos（腾讯云 COS SDK ~163KB）与 utils/CryptHelper（crypto-js + jsencrypt
// ~130KB）只在个别 action 内使用，改为调用点动态 import()，避免打进主 bundle。
import {
  setLoading as setLoadingAction,
  setUser as setUserAction,
  setIsCheckingAuth as setIsCheckingAuthAction,
  setOssToken as setOssTokenAction,
  setConfig as setConfigAction,
  setInitialRequestFinished as setInitialRequestFinishedAction,
  setAiChatDrawerStatus as setAiChatDrawerStatusAction,
  setAgentCustomerDrawerStatus as setAgentCustomerDrawerStatusAction,
  setPaymentStatus as setPaymentStatusAction,
  setDownloadSettingModalVisible as setDownloadSettingModalVisibleAction,
  setHasNewNotify as setHasNewNotifyAction,
  setAbTestConfig as setAbTestConfigAction
} from '../slices/mainSlice'

export function setLoading(data) {
  return setLoadingAction(data)
}

export function setAiChatDrawerVisible(visible, info) {
  return setAiChatDrawerStatusAction({
    visible,
    info: info || {}
  })
}

export function setAgentCustomerDrawerVisible(visible, info) {
  return setAgentCustomerDrawerStatusAction({
    visible,
    info: info || {}
  })
}

/**
 *
 * @param {boolean} visible
 * @param {string} sourceDetail
 * @param {number} vipKind 1:普通vip, 2:svip
 * @returns
 */
export function setPaymentVisible(
  visible,
  sourceDetail = '',
  vipKind = 1,
  isFromToView = false,
  onlySvip = true,
  onlyVVip = false,
  customContent: { variant: string; data: any } | null = null
) {
  return setPaymentStatusAction({
    visible,
    // TodayWork 客户端里给来源串加 todaywork_ 前缀。放在这一层是因为它是两类调用的唯一
    // 交汇点：hooks 的 open / openSvip / openVipByKind，以及 20 多个业务文件直接
    // dispatch(setPaymentVisible(...)) 绕过 hook 的写法。改这一处，弹窗内的曝光/点击/
    // 支付埋点和 /web/order/create 的 sourceDetail 读的都是这同一份值，不会对不上
    sourceDetail: withClientPrefix(sourceDetail),
    vipKind,
    isFromToView,
    onlySvip,
    onlyVVip,
    customContent
  })
}

export function setHasNewNotify(value: any) {
  if (value) {
    localStorage.setItem('hasNewNotify', '1')
  } else {
    localStorage.removeItem('hasNewNotify')
  }

  return setHasNewNotifyAction(value)
}

export function setDownloadSettingModalVisible(visible) {
  return setDownloadSettingModalVisibleAction(visible)
}

/**
 * 设置AB测试配置
 * @param {object} config AB测试配置对象
 * @returns
 */
export function setABTestConfig(config) {
  return setAbTestConfigAction(config)
}

export function fetchVerifyCode(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v3/send/login/vericode',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchVerifyCodeV3(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v3/send/login/vericode/safe',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchVerifyCodeShuMei(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v3/send/login/vericode/shumei',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 获取登录二维码
 * @returns
 */
export function fetchWxQr() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/wechat/parameters/qrcode',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 获取登录二维码扫码结果
 */
export function fetchWxQrResult() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/wechat/scan/qrcode/status',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (
          result.code === 200 &&
          result.data.status === 0 &&
          !!result.data.nickname
        ) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
          dispatch(fetchUserPoliceList())
        }

        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 手机短信验证码校验
 */
export function verifySMSCode(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/user/with/vericode',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function loginWithWechat(data) {
  return (dispatch, getState) => {
    dispatch(setIsCheckingAuthAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v3/login',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (
          result.code === 200 &&
          result.data.status === 0 &&
          !!result.data.nickname
        ) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
          dispatch(fetchUserPoliceList())
        }
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setIsCheckingAuthAction(false))
      })
  }
}

export function loginWithMobile(data) {
  return (dispatch, getState) => {
    dispatch(setIsCheckingAuthAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v3/login/with/vericode',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (
          result.code === 200 &&
          result.data.status === 0 &&
          !result.data.isNewGroup
        ) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
          dispatch(fetchUserPoliceList())
        }
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setIsCheckingAuthAction(false))
      })
  }
}

export function fetchUser() {
  return (dispatch, getState) => {
    dispatch(setIsCheckingAuthAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v2/currentuser',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        dispatch(
          setUserAction({
            user: data,
            activeModules: generateAllActiveModules()
          })
        )
        dispatch(fetchUserPoliceList())
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setIsCheckingAuthAction(false))
      })
  }
}

/**
 * 微信 OAuth2 登录回调
 * @param {Object} data - 包含 code 和 state 的对象
 */
export function fetchWechatOAuth2(data) {
  return (dispatch, getState) => {
    dispatch(setIsCheckingAuthAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/wechat/onekey/login',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: data.token
        })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return result.data
      })
      .then((result) => {
        dispatch(setIsCheckingAuthAction(false))
        if (result.status === 0) {
          dispatch(
            setUserAction({
              user: result,
              activeModules: generateAllActiveModules()
            })
          )
          dispatch(fetchUserPoliceList())
        }
        return Promise.resolve(result)
      })
      .catch((err) => {
        dispatch(setIsCheckingAuthAction(false))
        SentryUtils.captureFetchException(err, config)
        sensors.track('web_workgroup_wechat_oauth_login_fail')
        return Promise.reject(err)
      })
  }
}

export function logout() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/logout',
      arguments: {
        method: 'POST'
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((data) => {
        // 当前用户退出的团队，key是用户id，value是团队id
        console.log('getState()', getState())
        const lastLogoutGroupObj = {
          [getState().main.user?.user_id]: getState().group.groupId
        }
        localStorage.setItem(
          'last_logout_group_id',
          JSON.stringify(lastLogoutGroupObj)
        )
        localStorage.setItem('group_id', '')
        if (getState().main.isDesktop) {
          desktopLib.logoutSuccess()
        } else {
          window.location.href = '/'
        }
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
      })
  }
}

export function finishNickname(data) {
  return (dispatch, getState) => {
    dispatch(setLoadingAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/user/nickname',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (result.code === 200 && result.data.status === 0) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
          dispatch(fetchUserPoliceList())
        }
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setLoadingAction(false))
      })
  }
}

export function finishGroupInfo(data) {
  return (dispatch, getState) => {
    dispatch(setLoadingAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/update/groupinfo',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (result.code === 200 && result.data.status === 0) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
        }
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setLoadingAction(false))
      })
  }
}

export function createGroup(data) {
  return (dispatch, getState) => {
    dispatch(setLoadingAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/industry/create',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (result.code === 200 && result.data.status === 0) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
        }
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setLoadingAction(false))
      })
  }
}

export function fetchInviteStatus(inviteId) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v2/invite/status',
      arguments: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ invite_id: inviteId })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => Promise.resolve(result.data))
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function searchGroupByName(searchName) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/app/group/search',
      arguments: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ searchName })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => Promise.resolve(result.data))
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function joinGroupApply(groupID, departmentID = 0, source?: string) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/v4/join',
      arguments: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          groupID,
          departmentID,
          ...(source ? { source } : {})
        })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => Promise.resolve(result.data))
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function wechatBindMobile(token) {
  return (dispatch, getState) => {
    dispatch(setLoadingAction(true))
    let config
    if (token) {
      // onekey bind 使用新的 onekey 绑定接口
      config = {
        url: __API_SERVER_HOST__ + '/web/workgroup/wechat/onekey/bind',
        arguments: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token
          })
        }
      }
    } else {
      config = {
        url: __API_SERVER_HOST__ + '/web/workgroup/bind/cur',
        arguments: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (
          result.code === 200 &&
          result.data.status === 0 &&
          !!result.data.nickname
        ) {
          dispatch(
            setUserAction({
              user: result.data,
              activeModules: generateAllActiveModules()
            })
          )
          dispatch(fetchUserPoliceList())
        }
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setLoadingAction(false))
      })
  }
}

// 解绑微信和手机号的关联关系
export function wechatUnbindMobile() {
  return (dispatch, getState) => {
    dispatch(setLoadingAction(true))
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/unbind/user',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (result.code === 200 && result.data.status === 0) {
          return Promise.resolve(result.data)
        }

        return Promise.reject(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch(setLoadingAction(false))
      })
  }
}

export function fetchUploadToken(data?: any) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/oss/tokens',
      arguments: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        dispatch(setOssTokenAction(result.data))
        localStorage.setItem('ossData', JSON.stringify(result.data))
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
      })
  }
}

export function getOSSToken() {
  return (dispatch: any, getState: any) => {
    let ossData: any = null
    const ossDataStr = localStorage.getItem('ossData')
    if (ossDataStr) {
      try {
        ossData = JSON.parse(ossDataStr)
      } catch (error) {
        console.log('ossData parse error!')
      }
    }
    if (
      ossData &&
      ossData['net-cloud'] &&
      ossData['net-cloud'].expire > Date.now() / 1000 &&
      ossData['fe-xhey'] &&
      ossData['fe-xhey'].expire > Date.now() / 1000
    ) {
      dispatch(setOssTokenAction(ossData))
      return Promise.resolve(ossData)
    } else {
      return dispatch(fetchUploadToken())
    }
  }
}

export async function uploadToOSS(data) {
  let formData = new FormData()
  for (let key in data) {
    formData.append(key, data[key])
  }
  // net-cloud 桶跨域白名单只放行正式域名，本地开发（localhost）直传会被浏览器
  // CORS 拦成 403，照片全部标红失败；改走 vite dev server 转发（代理配置见
  // vite.config.ts 的 /__oss/net-cloud），仅本地生效，不影响 test/staging/prod 产物
  const uploadEndpoint = __DEBUG__
    ? '/__oss/net-cloud/'
    : 'https://net-cloud.oss-cn-beijing.aliyuncs.com'
  return fetch(uploadEndpoint, {
    method: 'POST',
    body: formData,
    credentials: 'include'
  })
    .then((data) => {})
    .catch((err) => {
      SentryUtils.captureFetchException(err, null)
      return Promise.reject(null)
    })
}

// 照片双云上行，腾讯云上传
export async function uploadToTencentCOS(data) {
  try {
    const { default: cos } = await import('../utils/cos')
    const res = await cos.uploadFile({
      Bucket: 'net-cloud-1322834237', // 填写自己的 bucket，必须字段
      Region: 'ap-guangzhou', // 存储桶所在地域，必须字段
      Key: data.key, // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
      Body: data.file, // 上传文件对象
      SliceSize: 1024 * 1024 * 30, // 触发分块上传的阈值，超过5MB 使用分块上传，小于5MB使用简单上传。可自行设置，非必须
      onProgress: function (progressData) {
        console.log('上传进度：', progressData)
      },
      onTaskReady: function (id) {
        // 非必须
        console.log('id', id)
      }
    })
    console.log('上传成功', res)
  } catch (e) {
    console.error('上传失败', e)
    return Promise.reject(e)
  }
}

export function fetchConfig(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/config/query',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        dispatch(setConfigAction(data.items))
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
      })
  }
}

/**
 * 查询90天前资源解冻状态
 */
export function fetchPhotoRestoreStatus(params, byInterval = false) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/photo/restore/status',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        if (data.status === Status.photoNotReady && !byInterval) {
          Modal.warning({
            title: '90天前照片正在准备中',
            content: '照片数量庞大，首次加载预计等待1分钟，请稍后。',
            okText: '我知道了'
          })
          sensors.track('web_show_pop_unfreeze_photos_of_90_days_before', {
            pagePath: parsePlaceValue(),
            groupID: params.groupID
          })
        }
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
      })
  }
}

// 获取 udesk 签名
export function fetchUdeskSign() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/customer/service/token',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 获取行业数据
export function fetchIndustryList() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/industry/types',
      arguments: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 运营弹窗通知上报到服务端
export function reportNotice(params) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/user/notice/create',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 获取运营通知列表
export function fetchNoticeList(params) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/user/notice/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function toViewAction(toView) {
  return (dispatch, getState) => {
    if (toView.type === 'TOVIEW_WEB_WORKGROUP') {
      if (toView.subtype === 'to_page' && toView.content.path) {
        window.open(toView.content.path)
      } else if (toView.subtype === 'open_payment') {
        if (toView.content.vipKind === 'svip') {
          dispatch(
            setPaymentVisible(
              true,
              toView.content.sourceDetail,
              CONFIG.VIP_KIND.SVIP,
              true
            )
          )
        } else {
          dispatch(
            setPaymentVisible(
              true,
              toView.content.sourceDetail,
              CONFIG.VIP_KIND.VIP,
              true
            )
          )
        }
      } else if (toView.subtype === 'contact_us') {
        const state = getState()
        const user = state.main.user
        const group = state.group

        Promise.resolve().then(async () => {
          // 上报进线数据
          dispatch(reportContactUs())

          const url = 'https://webchat-sh.clink.cn/chat.html'

          const query: {
            accessId: string
            language: string
            visitorId: any
            visitorName: any
            tel: any
            customerFields?: string
          } = {
            accessId: 'b1eeb62e-c2f0-4d94-8e5d-ee0b28f936ae',
            language: 'zh_CN',
            visitorId: user?.user_id,
            visitorName: user?.nickname,
            tel: user?.mobile
          }

          const customerFields: Record<string, any> = {
            版本号: desktopLib.isDesktop ? desktopLib.clientInfo.version : '',
            来源页面: `${
              desktopLib.isDesktop ? 'PC端' : 'WEB端'
            }工作圈管理后台`,
            userid: user?.user_id,
            姓名: user?.nickname,
            登陆手机号: user?.mobile,
            团队名称: group.groupName,
            团队号: group.groupId,
            团队会员状态: group.isVip,
            autoUpdate: 1
          }

          try {
            const stat = await dispatch(fetchContacUsParams())

            customerFields['个人会员历史充值次数'] =
              stat.userStats.orderRecordCount
            customerFields['个人会员历史充值金额'] =
              stat.userStats.orderRecordSumAmount
            customerFields['团队会员历史充值次数'] =
              stat.groupStats.orderRecordCount
            customerFields['团队会员历史充值金额'] =
              stat.groupStats.orderRecordSumAmount
          } catch (e) {
            console.log(e)
          }

          query.customerFields = JSON.stringify(customerFields)

          const qs = Object.entries(query)
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join('&')

          const contactUrl = `${url}?${qs}`

          if (desktopLib.isDesktop) {
            desktopLib.openContact(contactUrl)
          } else {
            window.open(
              contactUrl,
              '_blank',
              `width=500,height=600,left=${
                (window.screen.availWidth - 500) / 2
              },top=${(window.screen.availHeight - 600) / 2})}`
            )
          }
        })
      }
    }
  }
}

/**
 * 向服务端上报在线客服进线数据
 */
export function reportContactUs() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/tr/user/report',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 获取联系客服所需的参数
 */
export function fetchContacUsParams() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/order/tr/stat',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchUserPoliceList() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/policy/oneuser/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userID: getState().main.user?.user_id
        })
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        if (data.status === 0) {
          dispatch({
            type: actionTypes.SET_GROUP_POLICY_LIST,
            payload: data.groupPolicyList
          })
          dispatch(setInitialRequestFinishedAction(true))
          const currentGroupID = getState().group.groupId
          if (currentGroupID && data.groupPolicyList) {
            const groupPolicy = data.groupPolicyList.find(
              (item) => item.groupID === currentGroupID
            )
            if (groupPolicy) {
              dispatch(setGroupAuthPolicy(groupPolicy))
              dispatch(setMyRole(groupPolicy.roleID))
              sensors.registerPage({
                role: sensorsRole(groupPolicy.roleID)
              })
            }
          }
        }
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchRsaPublicKey() {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/api/crypto/rsa/public-key',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 发送加密后的验证码请求
 */
export function fetchVerifyCodeV3Encrypt(data) {
  return async (dispatch, getState) => {
    try {
      // 1. 先串行请求 public-key
      const publicKeyData = await dispatch(fetchRsaPublicKey())
      if (!publicKeyData || !publicKeyData.publicKey) {
        throw new Error('获取 RSA 公钥失败')
      }

      const { publicKey } = publicKeyData
      const { AESHelper, RSAHelper } = await import('../utils/CryptHelper')

      // 2. 生成随机 AES 密钥
      const aesKey = AESHelper.generateKey()

      // 3. 使用 AES 加密业务数据
      const aesResult = AESHelper.encrypt(data, aesKey)

      // 4. 使用 RSA 加密 AES 密钥
      const encryptedKey = RSAHelper.encrypt(aesKey, publicKey)

      // 5. 组装加密后的请求体（匹配后端格式）
      const encryptedData = {
        key: encryptedKey, // RSA 加密后的 AES 密钥（Base64）
        iv: aesResult.iv, // AES IV（Base64）
        data: aesResult.ciphertext // AES 加密后的业务数据（Base64）
      }

      // 6. 发送加密后的请求
      let config = {
        url:
          __API_SERVER_HOST__ +
          '/web/workgroup/v3/send/login/vericode/safe/encrypted',
        arguments: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(encryptedData)
        }
      }

      return fetchHelper(dispatch, getState, config)
        .then((result) => {
          return Promise.resolve(result.data)
        })
        .catch((err) => {
          SentryUtils.captureFetchException(err, config)
          return Promise.reject(null)
        })
    } catch (err) {
      Sentry.captureException(err)
      return Promise.reject(err)
    }
  }
}

/**
 * 发送加密后的数美验证码请求
 */
export function fetchVerifyCodeShuMeiEncrypt(data) {
  return async (dispatch, getState) => {
    try {
      // 1. 先串行请求 public-key
      const publicKeyData = await dispatch(fetchRsaPublicKey())
      if (!publicKeyData || !publicKeyData.publicKey) {
        throw new Error('获取 RSA 公钥失败')
      }

      const { publicKey } = publicKeyData
      const { AESHelper, RSAHelper } = await import('../utils/CryptHelper')

      // 2. 生成随机 AES 密钥
      const aesKey = AESHelper.generateKey()

      // 3. 使用 AES 加密业务数据
      const aesResult = AESHelper.encrypt(data, aesKey)

      // 4. 使用 RSA 加密 AES 密钥
      const encryptedKey = RSAHelper.encrypt(aesKey, publicKey)

      // 5. 组装加密后的请求体（匹配后端格式）
      const encryptedData = {
        key: encryptedKey, // RSA 加密后的 AES 密钥（Base64）
        iv: aesResult.iv, // AES IV（Base64）
        data: aesResult.ciphertext // AES 加密后的业务数据（Base64）
      }
      // 6. 发送加密后的请求
      let config = {
        url:
          __API_SERVER_HOST__ +
          '/web/workgroup/v3/send/login/vericode/shumei/encrypted',
        arguments: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(encryptedData)
        }
      }
      return fetchHelper(dispatch, getState, config)
        .then((result) => {
          return Promise.resolve(result.data)
        })
        .catch((err) => {
          SentryUtils.captureFetchException(err, config)
          return Promise.reject(null)
        })
    } catch (err) {
      Sentry.captureException(err)
      return Promise.reject(err)
    }
  }
}

/**
 * 发送加密后的登录请求
 */

export function loginWithMobileEncrypt(data) {
  return async (dispatch, getState) => {
    dispatch(setIsCheckingAuthAction(true))
    try {
      // 1. 先串行请求 public-key
      const publicKeyData = await dispatch(fetchRsaPublicKey())
      if (!publicKeyData || !publicKeyData.publicKey) {
        throw new Error('获取 RSA 公钥失败')
      }

      const { publicKey } = publicKeyData
      const { AESHelper, RSAHelper } = await import('../utils/CryptHelper')

      // 2. 生成随机 AES 密钥
      const aesKey = AESHelper.generateKey()

      // 3. 使用 AES 加密业务数据
      const aesResult = AESHelper.encrypt(data, aesKey)

      // 4. 使用 RSA 加密 AES 密钥
      const encryptedKey = RSAHelper.encrypt(aesKey, publicKey)

      // 5. 组装加密后的请求体（匹配后端格式）
      const encryptedData = {
        key: encryptedKey, // RSA 加密后的 AES 密钥（Base64）
        iv: aesResult.iv, // AES IV（Base64）
        data: aesResult.ciphertext // AES 加密后的业务数据（Base64）
      }
      // 6. 发送加密后的请求

      let config = {
        url:
          __API_SERVER_HOST__ +
          '/web/workgroup/v3/login/with/vericode/encrypted',
        arguments: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(encryptedData)
        }
      }
      return fetchHelper(dispatch, getState, config)
        .then((result) => {
          if (
            result.code === 200 &&
            result.data.status === 0 &&
            !result.data.isNewGroup
          ) {
            dispatch(
              setUserAction({
                user: result.data,
                activeModules: generateAllActiveModules()
              })
            )
            dispatch(fetchUserPoliceList())
          }
          return Promise.resolve(result.data)
        })
        .catch((err) => {
          SentryUtils.captureFetchException(err, config)
          return Promise.reject(null)
        })
        .finally(() => {
          dispatch(setIsCheckingAuthAction(false))
        })
    } catch (err) {
      Sentry.captureException(err)
      return Promise.reject(err)
    }
  }
}
